@if (sideNavService.selectedMainLink(); as selectedMainItem) {
  <div
    class="side-nav-header"
    [class.expanded]="sideNavStatus() === sideNavStatusEnum.expanded"
    [class.collapsed]="sideNavStatus() === sideNavStatusEnum.collapse">
    @if (sideNavStatus() === sideNavStatusEnum.collapse) {
      <div class="icon-container flex-row-center">
        <img class="img" [src]="activeDirectory()?.logo | resource: 'thumb:240x'" alt="Logo" />
      </div>
    } @else {
      <div class="companies-container">
        <sxw-dropdown-input
          [placeholder]="sideNavDropDownPlaceholder | translate"
          [options]="availableDirectories()"
          [useValue]="activeDirectory()"
          optionLabel="name"
          [showClear]="false"
          [dt]="{ smPaddingY: '9px', smPaddingX: '9px' }"
          theme="sidenav-dropdown"
          (onDropDownChange)="changeActiveDirectory($event)">
          <ng-template #item let-item>
            <div class="directory-dropdown-item d-flex gap-10 align-items-center">
              <img class="img" [src]="item.logo | resource: 'thumb:240x'" alt="directory image" />
              <span>{{ item.name }}</span>
            </div>
          </ng-template>
          <ng-template #selectedContent let-item>
            <div class="directory-dropdown-item d-flex gap-10 align-items-center">
              <img class="img" [src]="item.logo | resource: 'thumb:240x'" alt="directory image" />
              <span>{{ item.name }}</span>
            </div>
          </ng-template>
        </sxw-dropdown-input>
      </div>
    }
  </div>

  <div
    class="side-nav__collapse-btn"
    (click)="calculateSideNavStatus()"
    [class.expanded]="sideNavStatus() === sideNavStatusEnum.expanded"
    [class.collapsed]="sideNavStatus() === sideNavStatusEnum.collapse">
    <sxw-svg-icon
      name="sidebar"
      width="20"
      height="20"
      [class.active]="sideNavStatus() === sideNavStatusEnum.collapse || sideNavStatus() === sideNavStatusEnum.mouseleave">
    </sxw-svg-icon>
  </div>

  <div class="side-nav flex-row-start" #sideNav [class.expanded]="sideNavStatus() === sideNavStatusEnum.expanded">
    <app-icons-bar
      [mainLinks]="sideNavService.mainLinks()"
      (onSelectItem)="clickItem($event)"
      icons-bar
      [class.expanded]="sideNavStatus() === sideNavStatusEnum.expanded"
      [class.collapsed]="sideNavStatus() === sideNavStatusEnum.collapse" />

    <app-links-nav
      links-nav
      [selectedMainItem]="selectedMainItem"
      (selectItem)="clickItem($event)"
      [class.expanded]="sideNavStatus() === sideNavStatusEnum.expanded"
      [class.collapsed]="sideNavStatus() === sideNavStatusEnum.collapse" />
  </div>
}
